import { useMemo } from 'react';

import Balota from '../../../common/components/Balota/Balota';
import { BALOTA_SIZES } from '../../../common/components/Balota/constants';
import { HISTORY_SIZE, TICKET_STATUS } from '../../../core/constants/lottery';
import { HOME_ANCHORS } from '../../../core/constants/routes';
import { formatDateTime } from '../../../core/utils/format';
import { useDraws } from '../../../global/contexts/lottery/draws';
import { useTickets } from '../../../global/contexts/lottery/tickets';

import '../styles/history.css';

function HistoryCard({ result, isLatest, hasWon }) {
    const classes = [
        'draw-history__card',
        isLatest ? 'draw-history__card--latest' : '',
        hasWon ? 'draw-history__card--won' : '',
    ].filter(Boolean).join(' ');

    return (
        <article className={classes}>
            <header className="draw-history__meta">
                <time className="draw-history__time">{formatDateTime(result.drawnAt)}</time>
                {isLatest && <span className="draw-history__badge">Último</span>}
                {hasWon && <span className="draw-history__badge draw-history__badge--won">Ganaste</span>}
            </header>

            <div className="draw-history__balls" aria-label={`Combinado ${result.number}`}>
                {result.digits.map((digit, index) => (
                    <Balota key={index} digit={digit} size={BALOTA_SIZES.SM} muted={!isLatest} />
                ))}
            </div>

            <span className="draw-history__number">{result.number}</span>
        </article>
    );
}

export default function DrawHistory() {
    const { history } = useDraws();
    const { tickets } = useTickets();

    const wonSlots = useMemo(
        () => new Set(
            tickets
                .filter(ticket => ticket.status === TICKET_STATUS.WON)
                .map(ticket => ticket.slotIndex),
        ),
        [tickets],
    );

    return (
        <section className="draw-history section" id={HOME_ANCHORS.HISTORY}>
            <div className="section__head">
                <div>
                    <h2 className="section__title">Últimos resultados</h2>
                    <p className="section__subtitle">
                        Los {HISTORY_SIZE} sorteos más recientes, del más nuevo al más antiguo.
                    </p>
                </div>
                <span className="pill">Un sorteo cada 30 min</span>
            </div>

            <ol className="draw-history__list">
                {history.map((result, index) => (
                    <li className="draw-history__item" key={result.slotIndex}>
                        <HistoryCard
                            result={result}
                            isLatest={index === 0}
                            hasWon={wonSlots.has(result.slotIndex)}
                        />
                    </li>
                ))}
            </ol>
        </section>
    );
}
